import { defineMessage } from 'services/localization';

export const messages = {
    selectOrganisation: defineMessage('select_organisation'),
    selectWorkflow: defineMessage('select_workflow'),
    toCompanyFieldLabel: defineMessage('copy_workflow_to_organisation'),
    workflowFieldLabel: defineMessage('workflow_you_want_to_copy_to'),
    copyWorkflowSettingsFieldLabel: defineMessage('copy_workflow_settings'),
    requiredFieldsError: defineMessage('please_fill_in_required_fields'),
};
